import React from 'react';
import termsOfUse from '../data/termsOfUse.json';
import PolicyTemplate, { PolicyData } from '../components/PolicyTemplate';

const TermsOfUse: React.FC = () => {
  return <PolicyTemplate policyData={termsOfUse as PolicyData} />;
};

export default TermsOfUse;
